// AUTO GENERATED FILE - Changes WILL be lost.
export const translations = {
  "betslip.title": "Boletim de apostas",
  "product.last60-row-single": "NBA Últimos 60 jogos individuais",
  "product.sb-english-single": "Jogo único da Soccerbet inglesa",
  "product.sb-italian-single": "Futebol italiano - aposta em uma única partida",
  "product.sb-greek-single": "Jogo único de futebol grego",
  "product.sb-english-league": "Liga Inglesa de Futebol (Soccerbet)",
  "product.sb-italian-league": "Liga Italiana de Futebol (Soccerbet)",
  "product.sb-greek-league": "Liga Grega de Soccerbet",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Colocar aposta",
  "betslip.clear": "Limpar tudo",
  "betslip.clearResult": "Limpar",
  "betslip.noSelections": "Adicione seleções para começar a apostar",
  "betslip.notLoggedIn": "Faça login para começar a apostar",
  "betslip.refresh": "Atualizar",
  "betslip.totalStake": "Aposta total",
  "betslip.noHistoryData": "Nenhuma informação de aposta disponível",
  "betslip.openBets": "Apostas abertas",
  "betslip.betHistory": "Histórico de Apostas",
  "betslip.betHistoryWon": "Vencida",
  "betslip.betHistoryLost": "Perdida",
  "loading.loading": "Carregando",
  "loading.account": "Carregando Conta",
  "loading.league": "Carregando Liga",
  "loading.gameweeks": "Carregando Semanas do Jogo",
  "loading.markets": "Carregando Mercados",
  "loading.bethistory": "Carregando histórico de apostas",
  "login.loginRequired": "É necessário fazer login",
  "login.loginToBet": "Faça login para começar a apostar",
  "navigation.back": "Voltar",
  "navigation.close": "Fechar",
  "video.liveStreamAvailable": "Transmissão ao vivo disponível",
  "video.logInToWatch": "Faça login para assistir",
  "error.error": "Erro",
  "error.404": "Página não Encontrada",
  "error.gameLaunchFailed": "Não foi possível iniciar o jogo",
  "error.unknownErrorCode": "Erro desconhecido: {code}",
  "error.minUnitStakeLimitExceeded": "A aposta mínima é {limit}",
  "error.maxUnitStakeLimitExceeded": "A aposta máxima é {limit}",
  "error.minTotalStakeLimitExceeded": "A aposta total mínima é {limit}",
  "error.maxTotalStakeLimitExceeded": "A aposta total máxima é {limit}",
  "error.stakeInvalidMultiple": "A aposta deve ser um múltiplo de {multiple}",
  "error.notPlaced": "Não Apostado",
  "error.wagerDisallowed": "Aposta não permitida",
  "error.errorEventIsOff": "O evento começou",
  "wagerType.Singles": "Simples",
  "wagerType.Doubles": "Duplas",
  "wagerType.Trebles": "Triplas",
  "wagerType.Accumulator": "Acumulada",
  "wagerType.Perm 4-Folds": "4 - Múltiplas",
  "wagerType.Perm 5-Folds": "5 - Múltiplas",
  "wagerType.Perm 6-Folds": "6 - Múltiplas",
  "wagerType.Perm 7-Folds": "7 - Múltiplas",
  "wagerType.Perm 8-Folds": "8 - Múltiplas",
  "wagerType.Perm 9-Folds": "9 - Múltiplas",
  "error.excess_bets": "Máximo de {limit} apostas simultâneas no recibo de apostas; por favor, remova uma aposta",
  "product.sb-turkish-league": "Liga Turca Soccerbet",
  "error.minBetslipLimitExceeded": "A aposta total mínima no cupom de apostas é {limit}",
  "error.maxBetslipLimitExceeded": "A aposta total máxima no boletim de apostas é {limit}",
  "error.exceededMaxPayout": "O pagamento máximo potencial é {limit}; por favor, reduza sua aposta.",
  "betslip.potentialReturns": "Retornos potenciais",
  "betslip.taxDisclaimer": "Todos os seus ganhos líquidos são tributados no momento da liquidação da aposta. O valor do imposto será calculado de acordo com os ganhos potenciais da aposta.",
  "error.maintenanceEnabled": "O servidor está passando por manutenção no momento",
  "error.internalError": "Erro interno",
  "error.invalidSession": "A sessão é inválida",
  "error.accountDisabled": "A conta está desativada",
  "error.invalidPlayerID": "ID de jogador inválido",
  "error.insufficientBalance": "Saldo insuficiente",
  "error.configError": "Erro de configuração",
  "error.betPlaceFailed": "Falha ao fazer a aposta",
  "error.invalidProductID": "ID de produto inválido",
  "error.playerReachedGamingLimits": "O jogador atingiu os limites de jogo responsável",
  "error.gameCycleDoesNotExist": "O ciclo do jogo não existe",
  "error.betAmountLimitExceeded": "Limite de ganho potencial excedido para jogadores não verificados",
  "betslip.netStake": "Participação líquida",
  "betslip.tax": "Imposto",
  "error.badReturns": "Os retornos potenciais são menores do que a participação bruta",
  "betslip.taxDisclaimerPoland": "Os prêmios serão reduzidos em 10% para valores acima de PLN 2.280.",
  "error.incompatibleVersion": "Versão do aplicativo não suportada. Atualize.",
  "product.iihf-row-single": "Campeonato Mundial da IIHF",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Retornar ao jogador",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "O RTP médio para esse jogo é {limit}",
  "error.betslipContainsInvalidOptions": "O comprovante de aposta contém opções inválidas em vermelho",
  "product.sb-scottish-single": "Jogo único de Soccerbet escocês",
  "product.sb-spanish-single": "Jogo único de Soccerbet espanhol",
  "product.sb-spanish-league": "Liga Espanhola de Soccerbet",
  "sb-english.team.ARS": "ARS",
  "sb-english.team.AST": "AST",
  "sb-english.team.BHA": "BHA",
  "sb-english.team.BOU": "BOU",
  "sb-english.team.BUR": "BUR",
  "sb-english.team.CHE": "CHE",
  "sb-english.team.CRY": "CRY",
  "sb-english.team.EVE": "EVE",
  "sb-english.team.LEI": "LEI",
  "sb-english.team.LIV": "LIV",
  "sb-english.team.MNC": "MNC",
  "sb-english.team.MNU": "MNU",
  "sb-english.team.NEW": "NEW",
  "sb-english.team.SOU": "SOU",
  "sb-english.team.TOT": "TOT",
  "sb-english.team.WAT": "WAT",
  "sb-english.team.WHU": "WHU",
  "sb-english.team.WOL": "WOL",
  "sb-english.team.NOR": "NOR",
  "sb-english.team.SHU": "SHU",
  "sb-english.team.LEE": "LEE",
  "sb-english.team.FUL": "FUL",
  "sb-english.team.WBA": "WBA",
  "sb-greek.team.AEK": "AEK",
  "sb-greek.team.APS": "APS",
  "sb-greek.team.ARI": "ARI",
  "sb-greek.team.AST": "AST",
  "sb-greek.team.ATR": "ATR",
  "sb-greek.team.GIA": "GIA",
  "sb-greek.team.LEV": "LEV",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLM",
  "sb-greek.team.PTK": "PTK",
  "sb-greek.team.PNS": "PNS",
  "sb-greek.team.PAO": "PAO",
  "sb-greek.team.PLT": "PLT",
  "sb-greek.team.XAN": "XAN",
  "sb-italian.team.MIL": "MIL",
  "sb-italian.team.ATA": "ATA",
  "sb-italian.team.BOL": "BOL",
  "sb-italian.team.BRE": "BRE",
  "sb-italian.team.CAG": "CAG",
  "sb-italian.team.CHI": "CHI",
  "sb-italian.team.FIO": "FIO",
  "sb-italian.team.GEN": "GEN",
  "sb-italian.team.INT": "INT",
  "sb-italian.team.JUV": "JUV",
  "sb-italian.team.LAZ": "LAZ",
  "sb-italian.team.NAP": "NAP",
  "sb-italian.team.ROM": "ROM",
  "sb-italian.team.SAM": "SAM",
  "sb-italian.team.UDI": "UDI",
  "sb-italian.team.VER": "VER",
  "nomorebets": "Não há mais apostas",
  "playtime": "Tempo de Jogo",
  "gameId": "ID do Jogo",
  "noGames": "Não há jogos disponíveis. Verifique em breve.",
  "Home": "Casa",
  "Away": "Visitante",
  "Visitor": "Visitante",
  "rules": "RÉGUAS",
  "soccerbet.gameWeek": "JOGO DA SEMANA",
  "soccerbet.noGameWeeks": "Não há semanas de jogo disponíveis. Verifique em breve.",
  "soccerbet.league": "Classificação da Liga",
  "soccerbet.table.name": "Name",
  "soccerbet.table.won": "V",
  "soccerbet.table.drawn": "E",
  "soccerbet.table.lost": "D",
  "soccerbet.table.points": "PT",
  "abbr.event.Both Teams To Score": "BTTS",
  "event.Both Teams To Score": "Ambos Times Marcam",
  "event.Over / Under": "Acima/Abaixo de",
  "event.Double Chance": "Dupla Chance",
  "event.Match Result": "Resultado da Partida",
  "event.Exact Goals": "Gols Exatos",
  "event.Correct Score": "Resultado Correto",
  "event.Match Result Both Score": "Resultado do Jogo Ambos Marcam",
  "event.Result Und/Over 1.5 Total Goals": "Resultado Acima/Abaixo de 1.5 gols totais",
  "event.Result Und/Over 2.5 Total Goals": "Resultado Acima/Abaixo de 2.5 gols totais",
  "event.Under Over 1.5 Total Goals": "Acima/Abaixo de 1.5 gols em total",
  "event.Under Over 2.5 Total Goals": "Acima/Abaixo de 2.5 gols em total",
  "event.Under Over 3.5 Total Goals": "Acima/Abaixo de 3.5 gols em total",
  "event.Under Over 4.5 Total Goals": "Acima/Abaixo de 4.5 gols totais",
  "event.Total Goals 1 To 2": "Total de Gols 1 a 2",
  "event.Total Goals 1 To 3": "Total de Gols 1 a 3",
  "event.Total Goals 1 To 4": "Total de Gols 1 a 4",
  "event.Total Goals 2 To 3": "Total de Gols 2 a 3",
  "event.Total Goals 2 To 4": "Total de Gols 2 a 4",
  "event.Under Over 1.5 Home Goals": "Acima/Abaixo de 1.5 gols em casa",
  "event.Under Over 1.5 Away Goals": "Acima/Abaixo de 1.5 gols do visitante",
  "event.Home Team Exact Goals": "Time em Casa Exatos Gols",
  "event.Away Team Exact Goals": "Time Visitante Exatos Gols",
  "selection.Yes": "Sim",
  "selection.No": "Não",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Sim",
  "selection.1+No": "1+Não",
  "selection.X+Yes": "X+Sim",
  "selection.X+No": "X+Não",
  "selection.2+Yes": "2+Sim",
  "selection.2+No": "2+Não",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "sobre",
  "selection.Under": "debaixo",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham F.",
  "abbr.sb-english.team.NOT": "NOT",
  "sb-spanish.team.ALV": "Alavancas",
  "sb-spanish.team.ATB": "Athletic Bilbao",
  "sb-spanish.team.ATM": "Atlético de Madri",
  "sb-spanish.team.FCB": "Barcelona",
  "sb-spanish.team.CAD": "Cádiz",
  "sb-spanish.team.CLV": "Celta de Vigo",
  "sb-spanish.team.ESP": "Espanyol",
  "sb-spanish.team.GET": "Getafe",
  "sb-spanish.team.GIR": "Girona",
  "sb-spanish.team.GRA": "Granada",
  "sb-spanish.team.LAP": "Las Palmas",
  "sb-spanish.team.MAL": "Mallorca",
  "sb-spanish.team.OSA": "Osasuna",
  "sb-spanish.team.RAY": "Rayo Vallecano",
  "sb-spanish.team.BET": "Real Betis",
  "sb-spanish.team.MAD": "Real Madrid",
  "sb-spanish.team.SOC": "Real Scoiedad",
  "sb-spanish.team.SEV": "Sevilha",
  "sb-spanish.team.VAL": "Valência",
  "sb-spanish.team.VIL": "Villarreal",
  "abbr.sb-spanish.team.ALV": "ALV",
  "abbr.sb-spanish.team.ATB": "ATB",
  "abbr.sb-spanish.team.ATM": "ATM",
  "abbr.sb-spanish.team.FCB": "FCB",
  "abbr.sb-spanish.team.CAD": "CAD",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "GIR",
  "abbr.sb-spanish.team.GRA": "GRA",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "MAL",
  "abbr.sb-spanish.team.OSA": "OSA",
  "abbr.sb-spanish.team.RAY": "RAY",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "MAD",
  "abbr.sb-spanish.team.SOC": "SOC",
  "abbr.sb-spanish.team.SEV": "SEV",
  "abbr.sb-spanish.team.VAL": "VAL",
  "abbr.sb-spanish.team.VIL": "VIL",
  "sb-scottish.team.ABE": "Aberdeen",
  "sb-scottish.team.CEL": "Celta",
  "sb-scottish.team.DDU": "Dundee United",
  "sb-scottish.team.HEA": "Corações",
  "sb-scottish.team.HIB": "Hiberiano",
  "sb-scottish.team.KIL": "Kilmarnock",
  "sb-scottish.team.LIV": "Livingston",
  "sb-scottish.team.MOT": "Motherwell",
  "sb-scottish.team.RAN": "Rangers",
  "sb-scottish.team.STJ": "São João Batista",
  "sb-scottish.team.STM": "St Mirren",
  "sb-scottish.team.DDE": "Dundee",
  "abbr.sb-scottish.team.ABE": "ABE",
  "abbr.sb-scottish.team.CEL": "CEL",
  "abbr.sb-scottish.team.DDU": "DDU",
  "abbr.sb-scottish.team.HEA": "HEA",
  "abbr.sb-scottish.team.HIB": "HIB",
  "abbr.sb-scottish.team.KIL": "KIL",
  "abbr.sb-scottish.team.LIV": "LIV",
  "abbr.sb-scottish.team.MOT": "MOT",
  "abbr.sb-scottish.team.RAN": "RAN",
  "abbr.sb-scottish.team.STJ": "STJ",
  "abbr.sb-scottish.team.STM": "STM",
  "abbr.sb-scottish.team.DDE": "DDE"
}
